import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';
import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';

import theme from '../../../theme';
import { postCandidateAgencyUpdate } from '../../../views/usersList/usersListReducer';
import { DropdownSearchBar } from '../../DropdownSearchBar/DropdownSearchBar';

const styles = theme?.components?.userCard;
const CandidateAgencySelectionModal = ({
  userAgency,
  userRecruiter,
  open,
  onClose,
  userName,
  userId,
}) => {
  const [selectedAgency, setSelectedAgency] = useState(
    userAgency ? { ...userAgency, _id: userAgency.ID } : null
  );
  const [selectedRecruiter, setSelectedRecruiter] = useState(
    userRecruiter ? { ...userRecruiter, _id: userAgency.ID } : null
  );

  useEffect(() => {
    // if a user changes the agency, clear the recruiter field
    if (selectedAgency?._id !== userAgency?.ID) {
      setSelectedRecruiter(null);
    }
  }, [selectedAgency, userAgency]);

  const dispatch = useDispatch();
  const onRecruiterAgencyChangeSubmit = () => {
    const changeRecruiterAgencyPayload = {
      id: userId,
      fields: {
        agencyId: selectedAgency._id,
        recruiterId: selectedRecruiter?._id,
      },
    };
    dispatch(postCandidateAgencyUpdate(changeRecruiterAgencyPayload));
  };

  const userFilters = [
    { operation: 'equals', field: 'role', value: UserRole.RECRUITER },
    { operation: 'equals', field: 'account.status', value: 'active' },
    { operation: 'equalsID', field: 'recruiter.agency.ID', value: selectedAgency?._id },
  ];

  const hasAChange =
    selectedAgency?._id !== userAgency?.ID || selectedRecruiter?._id !== userRecruiter?.ID;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography sx={styles.agencyHeaderStyle}>
          {LanguageConverterV2('userCard.candidate.agency.header', { userName })}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DropdownSearchBar
          onSubmitApiCallData={{
            httpMethod: 'POST',
            route: 'agency/read',
          }}
          optionDisplayField="name"
          placeholder={LanguageConverter('userCard.agency.placeholder')}
          sx={{}}
          value={selectedAgency ?? null}
          fullWidth
          onChange={(event, newValue) => {
            setSelectedAgency(newValue);
          }}
        />

        <DropdownSearchBar
          onSubmitApiCallData={{
            httpMethod: 'POST',
            route: 'v2/users/read',
          }}
          optionDisplayField="name"
          placeholder={LanguageConverter('userCard.recruiter.placeholder')}
          sx={{}}
          value={selectedRecruiter ?? null}
          fullWidth
          disabled={!selectedAgency?._id}
          onChange={(event, newValue) => {
            setSelectedRecruiter(newValue);
          }}
          additionalFilters={userFilters}
        />
        <Box sx={styles.agencyButtonContainer}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ ...styles.backButton, textTransform: 'none' }}
          >
            {LanguageConverter('buttonText.goBack')}
          </Button>
          <Button
            variant="contained"
            sx={styles.agencyChangeButton}
            onClick={onRecruiterAgencyChangeSubmit}
            disabled={!selectedAgency?._id || !hasAChange}
          >
            {LanguageConverter('buttonText.changeAgency')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

CandidateAgencySelectionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  userAgency: PropTypes.shape({
    ID: PropTypes.string,
    name: PropTypes.string,
  }),
  userRecruiter: PropTypes.shape({
    ID: PropTypes.string,
    name: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  userName: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

export default CandidateAgencySelectionModal;
